import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectService } from '../../services/project.service';
import { ConsultationService } from '../../services/consultation.service';
import { JourneyStep } from '../../models/project.model';

@Component({
  selector: 'app-process-journey',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './process-journey.component.html',
  styleUrl: './process-journey.component.scss'
})
export class ProcessJourneyComponent {
  private projectService = inject(ProjectService);
  private consultationService = inject(ConsultationService);

  journeySteps = this.projectService.journeySteps;
  activeStep = signal<JourneyStep>(this.journeySteps()[0]);

  selectStep(step: JourneyStep) {
    this.activeStep.set(step);
  }

  nextStep() {
    const steps = this.journeySteps();
    const currentIdx = steps.findIndex(s => s.stepNumber === this.activeStep().stepNumber);
    if (currentIdx < steps.length - 1) {
      this.activeStep.set(steps[currentIdx + 1]);
    }
  }

  prevStep() {
    const steps = this.journeySteps();
    const currentIdx = steps.findIndex(s => s.stepNumber === this.activeStep().stepNumber);
    if (currentIdx > 0) {
      this.activeStep.set(steps[currentIdx - 1]);
    }
  }

  talkToTeam() {
    this.consultationService.openModal({ projectType: 'Building Journey Consultation' });
  }
}
